import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
// import CloseIcon from "@mui/icons-material/Close";
import CloseIcon from '@material-ui/icons/Close';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiPaper-root": {
        minWidth: "800px",
        maxWidth: "90%",
    },
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.grey[600],
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));
const CustomizedDialogs = ({ open, onClose, allData }) => {
    const allApprovalData = allData?.data?.approvals || [];
    // Sort approvals by approvedAt in ascending order
    const sortedApprovals = [...allApprovalData].sort((a, b) => 
        new Date(b.approvedAt) - new Date(a.approvedAt)
    );
    return (
        <BootstrapDialog onClose={onClose} aria-labelledby='customized-dialog-title' open={open}>
            <DialogTitle sx={{ m: 0, p: 2 }} id='customized-dialog-title'>
                ALL BOM APPROVAL LIST
                <IconButton
                    aria-label='close'
                    onClick={onClose}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 13,
                        top: 10,
                        color: theme.palette.grey[500],
                    })}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label='customized table'>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>BOM TYPE</StyledTableCell>
                                <StyledTableCell align='center'>UPLOADED BY</StyledTableCell>
                                <StyledTableCell align='center'>SUBMITTED AT</StyledTableCell>
                                <StyledTableCell align='center'>APPROVED BY</StyledTableCell>
                                <StyledTableCell align='center'>APPROVED AT</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sortedApprovals.map((approval) => (
                                <StyledTableRow key={approval._id}>
                                    <StyledTableCell component='th' scope='row'>
                                        {approval.bomType}
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>
                                        {approval.submittedBy?.name}
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>
                                        {moment(approval.submittedAt).format("YYYY-MM-DD HH:mm:ss")}
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>
                                        {approval.approvedBy?.name}
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>
                                        {moment(approval.approvedAt).format("YYYY-MM-DD HH:mm:ss")}
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
        </BootstrapDialog>
    );
};
export default CustomizedDialogs;